import React, { useState } from "react";

export default function Avatar({
  user = {},
  className = "",
  size = 40, // 🔥 tamanho controlado por prop
  style = {},
  children,
  ...props
}) {
  const [error, setError] = useState(false);

  /** Retorna as iniciais do nome */
  function getInitials() {
    const nome = user.name || user.nome;

    if (!nome) return null;

    const partes = nome.trim().split(" ");

    const primeira = partes[0]?.[0]?.toUpperCase() || "";
    const segundaOuTerceira =
      partes[2]?.[0]?.toUpperCase() || partes[1]?.[0]?.toUpperCase() || "";

    return <strong className="fs-5">{primeira + segundaOuTerceira}</strong>;
  }

  /** Renderiza a imagem ou fallback */
  function Preview() {
    if (error) return getInitials();

    if (user?.logo) {
      const url = `https://playnee.s3.us-east-005.backblazeb2.com/prod/${user.logo}`;

      return (
        <img
          alt="avatar"
          src={url}
          className="w-100 h-100 rounded-circle object-fit-cover"
          onError={() => setError(true)}
        />
      );
    }

    return getInitials();
  }

  return (
    <div
      className={`rounded-circle d-flex align-items-center justify-content-center bg-primary text-white ${className}`}
      style={{
        width: size, // 🔥 Agora tamanho é controlado por prop
        height: size,
        minWidth: size,
        minHeight: size,
        overflow: "hidden",
        fontSize: size * 0.35, // texto proporcional
        ...style,
      }}
      {...props}
    >
      <Preview />
      {children}
    </div>
  );
}
